module.exports = __webpack_public_path__ + "static/EaLogo-c65790bc683a30ce8c3357b13baeb4bf.png";